module.exports = __webpack_public_path__ + "static/bread1-eba5347f607a8cd13843c65502d48d2b.jpg";